import { runtimeValue } from "@dowty/core";

const getSsoRuntimeValue = (key: "SSO_ISSUER_BASE_URL" | "SSO_PRODUCER_ENABLED" | "SAUFDINGS_API_BASE_URL" | "SPORTDINGS_API_URL" | "LERNDINGS_API_BASE_URL" | "SAUFDINGS_URL" | "SPORTDINGS_URL" | "LERNDINGS_URL" | "DIGDOC_URL"): string | undefined =>
    runtimeValue(key as unknown as keyof NonNullable<Window["__RUNTIME_CONFIG__"]>);

export const getSsoIssuerBaseUrl = (): string => {
    const runtimeUrl = getSsoRuntimeValue("SSO_ISSUER_BASE_URL");
    const buildUrl = process.env.REACT_APP_DOWTEX_SSO_ISSUER_BASE_URL;
    return (runtimeUrl || buildUrl || "").trim().replace(/\/+$/, "");
};

export const isSsoProducerEnabled = (): boolean => {
    const runtimeFlag = getSsoRuntimeValue("SSO_PRODUCER_ENABLED");
    const buildFlag = process.env.REACT_APP_DOWTEX_SSO_PRODUCER_ENABLED;
    return (runtimeFlag || buildFlag || "").trim().toLowerCase() === "true";
};

export const isDowtexAppOrigin = (origin: string): boolean => [
    getSsoRuntimeValue("SAUFDINGS_URL") || "https://saufdings.dowtex.com",
    getSsoRuntimeValue("SPORTDINGS_URL") || "https://sportdings.dowtex.com",
    getSsoRuntimeValue("LERNDINGS_URL") || "https://lerndings.dowtex.com",
    getSsoRuntimeValue("DIGDOC_URL") || "https://digdoc.dowtex.com",
].some(appUrl => {
    try {
        const url = new URL(appUrl);
        return url.protocol === "https:" && !url.username && !url.password && url.origin === origin;
    } catch {
        return false;
    }
});

type SsoApiApp = "saufdings" | "sportdings" | "lerndings";
type SsoApiRuntimeKey = "SAUFDINGS_API_BASE_URL" | "SPORTDINGS_API_URL" | "LERNDINGS_API_BASE_URL";

export const getSsoApiBaseUrl = (app: SsoApiApp): string => {
    const config: Record<SsoApiApp, { key: SsoApiRuntimeKey; buildUrl?: string; fallback?: string }> = {
        saufdings: { key: "SAUFDINGS_API_BASE_URL" },
        sportdings: { key: "SPORTDINGS_API_URL", buildUrl: process.env.REACT_APP_DOWTEX_SPORTDINGS_API_URL, fallback: "https://sportdingsapi2.dowtex.com" },
        lerndings: { key: "LERNDINGS_API_BASE_URL" },
    };
    const { key, buildUrl, fallback } = config[app];
    return (getSsoRuntimeValue(key) || buildUrl || fallback || "").trim().replace(/\/+$/, "");
};

export const getSsoStartUrl = (path: string, baseUrl: string): string | null => {
    try {
        const url = new URL(path, baseUrl);
        return (url.protocol === "http:" || url.protocol === "https:") && !url.username && !url.password
            ? url.toString()
            : null;
    } catch {
        return null;
    }
};
